export default __webpack_public_path__ + "static/media/shutterStock1.7976af43.jpg";